export enum ImageResizeMode {
    Scale = 0,
    Cover = 1,
    CoverExact = 3,
    Fit = 4,
    FitExact = 5,
}
